var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18 3.333v10A1.666 1.666 0 008.847 15h6.667a1.666 1.666 0 001.666-1.667V6.035a1.667 1.667 0 00-.502-1.192l-2.762-2.701a1.667 1.667 0 00-1.165-.475H8.847A1.667 1.667 0 007.18 3.333v0z",
    stroke: "#BDC1CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.847 15v1.667a1.667 1.667 0 01-1.667 1.666H5.513a1.667 1.667 0 01-1.666-1.666V7.5a1.667 1.667 0 011.666-1.667H7.18",
    stroke: "#BDC1CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/referrals/copy-eccf7519.svg";
export { SvgCopy as ReactComponent };